import { GlobalAdminsList} from "./GlobalAdminsList";

export default GlobalAdminsList;
